<template>
	<div>
		<v-row>
			<v-col cols="6" class="s-col-form">
				<!-- -->
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar label="1.- Información Recepción" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Guía" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.RcfWeightTicket | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<v-label>
									{{ "-" }}
								</v-label>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Neto" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.WbbNetWeight | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<v-label>
									{{ "-" }}
								</v-label>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ "Diferencia " + textCondition + typeCaseWeight }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infRefDifference | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.infRefDifferencePercentage | numberDefault }} %
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="6" class="s-col-form">
				<!--  -->
				<v-card dense outlined v-if="typeCaseWeight == 1 || (typeCaseWeight == 0)" :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar label="2.- Tolerancia Peso Neto - Peso Guía %" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<!---->
						<v-row >
							<v-col class="s-col-form">
								<h4>
									{{ "Tolerancia aceptada" + typeCaseWeight }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<s-text 
									v-model="AcceptedToleranceInput" 
									decimal
									:max="100"
								/>
								 
								<!-- :readonly="lotReception.RcfStatusSap == 2" -->
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiNetGuiToleranceAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ tolWeiNetGuiText | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row v-if="true">
			<v-col cols="12" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase3 + ' Descuentos a favor'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "KG Total descarte (selección)" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgTotalDiscartPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgTotalDiscartCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "kG a favor" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 style="color:#049967">
									{{ lotReception.DisFavKgFavorPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgFavorCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "KG descarte Actualizado (descontar)" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgDiscartUpdatePercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgDiscartUpdateCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase4 + ' Información Selección'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Actualizado" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infSelWeightUpdate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Lavado" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infSelWeightWash | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>

						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Descarte a favor" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infSelDiscartFavor | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="6" class="s-col-form" v-if="typeCaseWeight == 0 || typeCaseWeight == 1 || typeCaseWeight == 2 || typeCaseWeight == 3 || typeCaseWeight == 4">
				<!-- -->
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase5 + ' Tolerancia Descarte Seleccion %'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Tolerancia aceptada" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<s-text 
									v-model="AcceptedToleranceInputDiscart" 
									decimal 
								/>
								<!-- :readonly="lotReception.RcfStatusSap == 2" -->
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelToleranceAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Descarte no aceptada" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
<!-- typeCaseWeight == 4 -->
			<v-col cols="6" class="s-col-form" v-if="false">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar label="A favor" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "KG a favor" }}
								</h4>
							</v-col>
							
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.afavKgafavorPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.afavKgafavorCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Descarte Aceptable" }}
								</h4>
							</v-col>
							
							<v-col class="s-col-form">
								<h4 :style="colorText">
									 
									<s-text 
										v-model.number="afavKgafavorPercentageInput"
										decimal
										:disabled="AfavKgafavorPercentageInput == 3 || AfavKgafavorPercentageInput == 4"
										:value="0"
									/>
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.afavKgafavorCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Descarte no aceptada" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<!-- v-if="typeCaseWeight == 3 || typeCaseWeight == 4" -->
		<v-row class="mb-5">
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase6 + ' Descuentos totales'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Tolerancia no aceptada + Descarte no aceptada" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso a pagar" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisTotWeightPay | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase7 + ' Distribución Almacenes'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Final aceptable" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.RfsWeigth | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="success--text font-weight-black">
									{{ "Alm. 02" }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Merma aceptable" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.RfsWeightDiscart | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="red--text font-weight-black">
									{{ "Alm. 20" }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso a Favor" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.RfsWeigthNotSap | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="info--text font-weight-black">
									{{ "No SAP" }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	props: {
		lotReception: {}
	},
	data() {
		return {
			// lotReception: {},
			AcceptedToleranceInput: 0,
			AcceptedToleranceInputDiscart: 0,
			afavKgafavorPercentageInput:0,
			typeCaseWeight: 0,
			colorText: '',
			tolWeiNetGuiText: '',
			textcase3: "3.-",
			textcase4: "4.-",
			textcase5: "5.-",
			textcase6: "6.-",
			textcase7: "7.-",
			textCondition: "en Contra",
		}
	},
	// filters: {
	// 	numberDefaultKg: (value) => {
	// 		if( value == -Infinity ) return 0; 
	// 		if( value == Infinity ) return 0; 

	// 		if( isNaN(value) ) return 0; 
	// 		if( value == undefined ) return 0; 
	// 		// if( value < 0 ) return 0; 

	// 		console.log("valor tuberia", value)
	// 		return value;
	// 	}
	// },
	watch: {
		AcceptedToleranceInput() {
			this.getCalcule();

		},

		AcceptedToleranceInputDiscart() {
			this.getCalcule();
		},
		afavKgafavorPercentageInput(){
			this.getCalcule();
		},
	},
	methods: {
		getCalcule() {
			this.typeCaseWeight = 1;
			this.lotReception.RfsWeigthNotSap = 0;
			this.lotReception.RcfWeightCondition = 0;

			this.lotReception.infRefDifference = (this.lotReception.WbbNetWeight - this.lotReception.RcfWeightTicket).toFixed(4);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightTicket > 0
				? ((this.lotReception.infRefDifference / this.lotReception.RcfWeightTicket) * 100).toFixed(4)
				: 0


				console.log({ 
					RcfWeightTicket: this.lotReception.RcfWeightTicket,
					WbbNetWeight: this.lotReception.WbbNetWeight,
					infRefDifference: this.lotReception.infRefDifference ,
					discart: this.lotReception.discart 
				})


			if (this.lotReception.RcfWeightTicket >= this.lotReception.WbbNetWeight) {
				console.log("getCalculeCase1y2", "getCalculeCase1y2")
				this.typeCaseWeight = 1;
				this.getCalculeCase1y2();

				return;
			}

			this.textcase3 = "2.-";
			this.textcase4 = "3.-";
			this.textcase5 = "4.-";
			this.textcase6 = "5.-";
			this.textcase7 = "6.-";
			this.textCondition = "a Favor";
			this.lotReception.RcfWeightCondition = 1;
			 
			if (this.lotReception.RcfWeightTicket < this.lotReception.WbbNetWeight && 
				parseFloat(this.lotReception.infRefDifference) > parseFloat(this.lotReception.discart)) {
				console.log("getCalculeCase4", "getCalculeCase4")

				this.typeCaseWeight = 4;
				this.getCalculeCase4();
				return;
			}
			if (this.lotReception.RcfWeightTicket < this.lotReception.WbbNetWeight && 
				parseFloat(this.lotReception.infRefDifference) <= parseFloat(this.lotReception.discart)) {
				console.log("getCalculeCase3", "getCalculeCase3")

				this.typeCaseWeight = 3;
				this.getCalculeCase3();
			}


			// this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			// this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;
		},

		getCalculeCase1y2() {
			//peso guía mayor al peso neto - diferencia de peso guia y neto mayor a 2% - descarte mayor a 3%
			this.typeCaseWeight = 1;
			this.colorText = 'color:red';
			this.tolWeiNetGuiText = 'Diferencia no aceptada'

			this.lotReception.infRefDifference = (this.lotReception.RcfWeightTicket - this.lotReception.WbbNetWeight).toFixed(4);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightTicket > 0
				? ((this.lotReception.infRefDifference / this.lotReception.RcfWeightTicket) * 100).toFixed(4)
				: 0

			this.lotReception.tolWeiNetGuiToleranceAcceptedPercentageInput = this.AcceptedToleranceInput;
			if (parseFloat(this.AcceptedToleranceInput) >= parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = this.lotReception.infRefDifference;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = 0.00;
			}
			if (parseFloat(this.AcceptedToleranceInput) < parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = (this.lotReception.RcfWeightTicket * (this.AcceptedToleranceInput / 100)).toFixed(4);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = (this.lotReception.infRefDifferencePercentage - this.AcceptedToleranceInput).toFixed(4);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = (this.lotReception.infRefDifference - this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate).toFixed(4);
			}

			this.lotReception.infSelWeightUpdate = (this.lotReception.RcfWeightTicket - this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate).toFixed(4);
			this.lotReception.infSelWeightWash = (this.lotReception.WbbNetWeight - this.lotReception.discart).toFixed(4);

			this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = this.AcceptedToleranceInputDiscart;

			// console.log("this.AcceptedToleranceInputDiscart", this.AcceptedToleranceInputDiscart)
			// console.log("this.this.lotReception.discartPercentage", this.lotReception.discartPercentage)
			if (parseFloat(this.AcceptedToleranceInputDiscart) >= parseFloat(this.lotReception.discartPercentage)) {
				//samir
				console.log({ AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart })
				console.log({ discartPercentage: this.lotReception.discartPercentage })
				console.log("1")
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = this.lotReception.discart;////.DisFavKgDiscartUpdateCalculate
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = 0.00;

				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.discartPercentage;//SAMIR
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			if (parseFloat(this.AcceptedToleranceInputDiscart) < parseFloat(this.lotReception.discartPercentage)) {
				//samir
				console.log("2")
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (this.lotReception.WbbNetWeight * (this.AcceptedToleranceInputDiscart / 100)).toFixed(4);
				console.log({ tolWeiDisSelToleranceAcceptedCalculate: this.lotReception.tolWeiDisSelToleranceAcceptedCalculate })
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.discartPercentage - this.AcceptedToleranceInputDiscart).toFixed(4);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = (this.lotReception.discart - this.lotReception.tolWeiDisSelToleranceAcceptedCalculate).toFixed(4);

				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage ?? 0;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate ?? 0;

				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}

			this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted = (parseFloat(this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate) + parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate)).toFixed(4);
			this.lotReception.DisTotWeightPay = (this.lotReception.RcfWeightTicket - this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted).toFixed(4);

			this.lotReception.RfsWeightDiscart = (parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate) + parseFloat(this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate)).toFixed(4);
			this.lotReception.RfsWeigth = (parseFloat(this.lotReception.DisTotWeightPay) - parseFloat(this.lotReception.RfsWeightDiscart)).toFixed(4);

			this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;
		},

		getCalculeCase3() {
			//peso guía mayor al peso neto - diferencia de peso guia y neto menor a 2% - descarte menor a 3%
			this.typeCaseWeight = 3;
			this.colorText = 'color:green';
			this.tolWeiNetGuiText = 'KG a favor';

			this.lotReception.infRefDifference = (this.lotReception.WbbNetWeight - this.lotReception.RcfWeightTicket).toFixed(4);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightTicket > 0
				? ((this.lotReception.infRefDifference / this.lotReception.RcfWeightTicket) * 100).toFixed(4)
				: 0

			this.lotReception.tolWeiNetGuiToleranceAcceptedPercentageInput = this.AcceptedToleranceInput;
			if (parseFloat(this.AcceptedToleranceInput) >= parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = this.lotReception.infRefDifference;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = 0.00;
			}
			if (parseFloat(this.AcceptedToleranceInput) < parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = (this.lotReception.RcfWeightTicket * (this.AcceptedToleranceInput / 100)).toFixed(4);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = (this.lotReception.infRefDifferencePercentage - this.AcceptedToleranceInput).toFixed(4);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = (this.lotReception.infRefDifference - this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate).toFixed(4);
			}

			this.lotReception.DisFavKgTotalDiscartPercentage = (this.lotReception.discart / this.lotReception.RcfWeightTicket * 100).toFixed(4)
			this.lotReception.DisFavKgTotalDiscartCalculate = this.lotReception.discart;
			this.lotReception.DisFavKgFavorPercentage = this.lotReception.infRefDifferencePercentage;
			this.lotReception.DisFavKgFavorCalculate = this.lotReception.infRefDifference;
			this.lotReception.DisFavKgDiscartUpdateCalculate = (this.lotReception.DisFavKgTotalDiscartCalculate - this.lotReception.DisFavKgFavorCalculate).toFixed(4);
			this.lotReception.DisFavKgDiscartUpdatePercentage = ((this.lotReception.DisFavKgDiscartUpdateCalculate / this.lotReception.RcfWeightTicket) * 100).toFixed(4);



			this.lotReception.infSelWeightUpdate = (this.lotReception.RcfWeightTicket);
			//peso lavado
			this.lotReception.infSelWeightWash = (this.lotReception.WbbNetWeight - this.lotReception.discart);

			this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = this.AcceptedToleranceInputDiscart;
			// if(this.AcceptedToleranceInputDiscart >= this.lotReception.discartPercentage) 
			console.log({
				"if": "antes de el if",
				AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart,
				DisFavKgDiscartUpdatePercentage: this.lotReception.DisFavKgDiscartUpdatePercentage,
			})

			if (parseFloat(this.AcceptedToleranceInputDiscart) >= parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage)) {
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = this.lotReception.DisFavKgDiscartUpdateCalculate;//.discart;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = 0.00;
				console.log({ "if": 1 })

				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			// if(this.AcceptedToleranceInputDiscart < this.lotReception.discartPercentage) 
			// RcfWeightTicket
			if (parseFloat(this.AcceptedToleranceInputDiscart) < parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage)) {
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (this.lotReception.WbbNetWeight * (this.AcceptedToleranceInputDiscart / 100)).toFixed(4);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.DisFavKgDiscartUpdatePercentage - this.AcceptedToleranceInputDiscart).toFixed(4);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = ((this.lotReception.WbbNetWeight * this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage) / 100).toFixed(4);
				console.log({ "if": 2 })

				// this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			// console.log({ AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart })
			// console.log({ discartPercentage: this.lotReception.DisFavKgDiscartUpdatePercentage })
			// console.log({ tolWeiDisSelToleranceAcceptedCalculate: this.lotReception.tolWeiDisSelToleranceAcceptedCalculate, tern: "3" })

			this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted = (parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate)).toFixed(4);
			this.lotReception.DisTotWeightPay = (this.lotReception.RcfWeightTicket - this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted).toFixed(4);

			console.log({
				RfsWeightDiscart: this.lotReception.tolWeiDisSelToleranceAcceptedCalculate,
				tolWeiNetGuiToleranceAcceptedCalculate: this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate
			})
// this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate
			this.lotReception.RfsWeightDiscart = (parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate) + parseFloat(0)).toFixed(4);
			// this.lotReception.RfsWeigth = (parseFloat(this.lotReception.DisTotWeightPay) - parseFloat(this.lotReception.RfsWeightDiscart)).toFixed(4);//cambie 
			this.lotReception.RfsWeigth = (parseFloat(this.lotReception.infSelWeightWash) - parseFloat(0)).toFixed(4);

			console.log({ RfsWeightDiscart: this.lotReception.RfsWeightDiscart })
			console.log({ RfsWeigth: this.lotReception.RfsWeigth })

			this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;
		},

		getCalculeCase4() {
			//peso guía mayor al peso neto 
			this.typeCaseWeight = 4;
			this.colorText = 'color:green';
			this.tolWeiNetGuiText = 'KG a favor';

			this.lotReception.infRefDifference = (this.lotReception.WbbNetWeight - this.lotReception.RcfWeightTicket).toFixed(4);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightTicket > 0
				? ((this.lotReception.infRefDifference / this.lotReception.WbbNetWeight) * 100).toFixed(4)
				: 0;

			//samir

			this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = this.AcceptedToleranceInputDiscart;
			// if(this.AcceptedToleranceInputDiscart >= this.lotReception.discartPercentage) 
			console.log({
				"if": "antes de el if",
				AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart,
				DisFavKgDiscartUpdatePercentage: this.lotReception.DisFavKgDiscartUpdatePercentage,
			})

			if (parseFloat(this.AcceptedToleranceInputDiscart) >= parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage)) {
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = this.lotReception.DisFavKgDiscartUpdateCalculate;//.discart;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = 0.00;
				console.log({ "if": 1 })

				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			// if(this.AcceptedToleranceInputDiscart < this.lotReception.discartPercentage) 
			if (parseFloat(this.AcceptedToleranceInputDiscart) < parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage)) {
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (this.lotReception.WbbNetWeight * (this.AcceptedToleranceInputDiscart / 100)).toFixed(4);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.DisFavKgDiscartUpdatePercentage - this.AcceptedToleranceInputDiscart).toFixed(4);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = ((this.lotReception.WbbNetWeight * this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage) / 100).toFixed(4);
				console.log({ "if": 2 })


				// this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
//ultimo

			// DisFavKgDiscartUpdateCalculate
			this.lotReception.DisFavKgTotalDiscartPercentage = this.lotReception.discartPercentage
			this.lotReception.DisFavKgTotalDiscartCalculate = this.lotReception.discart;
			this.lotReception.DisFavKgFavorPercentage = this.lotReception.infRefDifferencePercentage;
			this.lotReception.DisFavKgFavorCalculate = this.lotReception.infRefDifference;
			this.lotReception.DisFavKgDiscartUpdatePercentage = ((this.lotReception.DisFavKgFavorPercentage - this.lotReception.DisFavKgTotalDiscartPercentage)).toFixed(4);
			this.lotReception.DisFavKgDiscartUpdateCalculate = (this.lotReception.DisFavKgFavorCalculate - this.lotReception.DisFavKgTotalDiscartCalculate).toFixed(4);

			//case4
			this.lotReception.DisFavKgDiscartUpdatePercentage = Math.abs(this.lotReception.DisFavKgDiscartUpdatePercentage);
			this.lotReception.DisFavKgDiscartUpdateCalculate = Math.abs(this.lotReception.DisFavKgDiscartUpdateCalculate)


			this.lotReception.infSelWeightUpdate = (this.lotReception.RcfWeightTicket).toFixed(4);
			this.lotReception.infSelWeightWash = (this.lotReception.WbbNetWeight - this.lotReception.discart).toFixed(4);
			this.lotReception.infSelDiscartFavor = (this.lotReception.infRefDifference - this.lotReception.discart).toFixed(4);

			this.lotReception.infSelDiscartFavor = Math.abs(this.lotReception.infSelDiscartFavor);

			this.lotReception.afavKgafavorPercentage = ((this.lotReception.infSelDiscartFavor / this.lotReception.WbbNetWeight) * 100).toFixed(4);
			if (parseFloat(this.lotReception.afavKgafavorPercentage) < this.afavKgafavorPercentageInput) {

				console.log("sa 1")
				this.lotReception.afavKgafavorCalculate = ((this.lotReception.afavKgafavorPercentage * this.lotReception.WbbNetWeight)/100).toFixed(4)

			}else{
				this.lotReception.afavKgafavorCalculate = ((this.lotReception.afavKgafavorPercentageInput * this.lotReception.WbbNetWeight)/100).toFixed(4)
				console.log("sa 2")

			}

			this.lotReception.afavKgafavorPercentageInput = this.afavKgafavorPercentageInput;
			 
			this.lotReception.RfsWeightDiscart = parseFloat(0).toFixed(4);
			this.lotReception.RfsWeigthNotSap = parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate).toFixed(4);
			// this.lotReception.RfsWeightDiscart = (parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate) + parseFloat(this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate)).toFixed(4);
			// this.lotReception.RfsWeigth = (parseFloat(this.lotReception.DisTotWeightPay) - parseFloat(this.lotReception.RfsWeightDiscart)).toFixed(4);
			// this.lotReception.RfsWeigth = (parseFloat(this.lotReception.infSelWeightWash)).toFixed(4);//infSelWeightUpdate
			this.lotReception.RfsWeigth = (parseFloat(this.lotReception.infSelWeightUpdate) + parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate)).toFixed(4);//infSelWeightUpdate
			// this.lotReception.RfsWeigthNotSap = (this.lotReception.infSelWeightWash - this.lotReception.RfsWeigth).toFixed(4);
			
			
			this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;
		}

	},

	created() {
		// this.lotReception = this.lotReceptionInput;
 
		
	},
	mounted() {

		console.log( { 
			TypeWeight: this.lotReception.TypeWeight, 
			status: "mounted guide",
			AcceptedToleranceInputDiscart : this.AcceptedToleranceInput,
			AcceptedToleranceInput: this.lotReception.AcceptedToleranceInput,
			AcceptedToleranceInputDiscart: this.lotReception.AcceptedToleranceInputDiscart
		 } )
		 
		this.AcceptedToleranceInput =  this.lotReception.AcceptedToleranceInput ?? 0;
		this.AcceptedToleranceInputDiscart = this.lotReception.AcceptedToleranceInputDiscart ?? 0;
		this.AfavKgafavorPercentageInput = this.lotReception.AfavKgafavorPercentageInput ?? 0;
		
		this.getCalcule();
	}
}
</script>
